import { createFileRoute } from "@tanstack/react-router";
import { safeJsonLd } from "@/lib/structured-data";
import { bookingPageCrumbs, getClinicStructuredData } from "@/lib/structured-data/clinic";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/denver")({
  head: () => ({
    meta: [
      // Indexable since 3 Oct 2026, as on the old production site (Wayback
      // 2025 shows "index, follow"). The sitemap lists this page.
      // Title and meta: the WordPress copy (staging, 6 Oct 2026), cut to 60
      // characters. H1 names the procedure and the city (rule from Anthony, 6 Oct 2026).
      { title: "Schedule a FREE Hair Transplant Consultation in Denver, CO" },
      {
        name: "description",
        content:
          "Schedule your free hair restoration consult with RESTORE in Denver, Colorado. You can do it in person or virtually. Client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "Schedule a FREE Hair Transplant Consultation in Denver, CO",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Denver, Colorado.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/denver/",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({
          "@graph": getClinicStructuredData("denver", bookingPageCrumbs("Denver", "/schedule-a-consult/denver/")),
        }),
      },
    ],
  }),
  component: ScheduleDenverPage,
});

function ScheduleDenverPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Transplant Consultation in Denver, CO
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Denver.
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=49646910" />
        </div>
      </main>
      <Footer />
    </div>
  );
}